<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'screen-form',
})
</script>
<template>
  <el-form
    v-bind="props"
    ref="screenFormContainer"
    :label-width="labelSize === 'small' ? '64px' :
      labelSize === 'default' ? '90px' : labelWidth"
  >
    <section class="form-container">
      <slot></slot>

      <div
        class="btn-container"
        :style="{
          justifyContent: btnAlign === 'left' ? 'flex-start' : 'flex-end'
        }"
      >
        <slot name="buttons">
          <el-button
            type="primary"
            @click="doSearchHandle()"
          >
            查询
          </el-button>
          <el-button @click="doResetHandle(screenFormContainer)">重置</el-button>
        </slot>
      </div>
    </section>
  </el-form>
</template>

<script lang="ts" setup name="screen-form">
  import {
    onMounted, onUnmounted, ref, provide,
  } from 'vue';
  import type { FormProps, FormInstance } from 'element-plus';

  type LFFormProps = FormProps & {
    labelSize?: string
    [key: string]: any
  }

  const props = defineProps<LFFormProps>();

  const emits = defineEmits(['do-search']);

  const screenFormContainer = ref<FormInstance>();
  const computedSpan = ref(0);
  const btnAlign = ref('left');

  provide('$_computed_span', computedSpan);

  const debounce = (fn: any, delay = 300) => {
    let timerId:any = null;
    return (...args: any) => {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const computedStyle = () => {
    try {
      if (screenFormContainer.value) {
        const wWidth = document.documentElement.offsetWidth;
        // const splitNum = wWidth >= 1920 ? 6 : wWidth >= 1600 ? 5 : 4;

        const formItems = screenFormContainer.value.$el.querySelectorAll('.__lf-form-item');
        const formItemLength = (formItems?.length + 1) || 0;

        if (formItemLength === 0) {
          computedSpan.value = 100;
          btnAlign.value = 'left';
        } else if (wWidth >= 1920) {
          if (formItemLength === 7) {
            computedSpan.value = 15;
          } else {
            computedSpan.value = 100 / 6;
          }
          btnAlign.value = formItemLength <= 7 ? 'left' : 'right';
        } else if (wWidth >= 1600) {
          if (formItemLength === 6) {
            computedSpan.value = 17.8;
          } else {
            computedSpan.value = 100 / 5;
          }
          btnAlign.value = formItemLength <= 6 ? 'left' : 'right';
        } else {
          if (formItemLength === 5) {
            computedSpan.value = 21;
          } else {
            computedSpan.value = 100 / 4;
          }
          btnAlign.value = formItemLength <= 5 ? 'left' : 'right';
        }
      }
    } catch (error) {
      console.log('🚀 ~ onMounted ~ error', error);
    }
  };

  const doSearchHandle = () => {
    emits('do-search');
  };
  const doResetHandle = (formEle: FormInstance | undefined) => {
    formEle?.resetFields();
    const isReset = true;
    emits('do-search', isReset);
  };

  onMounted(() => {
    if (screenFormContainer.value) {
      computedStyle();

      window.addEventListener('resize', debounce(computedStyle));
    }
  });

  defineExpose({
    computedStyle,

  });
  onUnmounted(() => {
    window.removeEventListener('resize', debounce(computedStyle));
  });
</script>

<style lang="scss" scoped>
  .form-container{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-width: 1000px;
  }

  .btn-container{
    display: flex;
    flex: 1;
    margin-bottom: 12px;
    padding-left: 12px;

    :deep(.#{$namespace}-button) {
      width: 60px;
    }
  }
</style>
